/*
  Recent-viewers pill.
  block: one stable pseudo-random number per product per session.
*/
(function () {
  'use strict';

  if (window.mxpvInit) return;
  window.mxpvInit = true;

  var SESSION_KEY = 'mxpv_' + window.location.pathname;

  function getCount() {
    try {
      var stored = sessionStorage.getItem(SESSION_KEY);
      if (stored) return parseInt(stored, 10);
    } catch (e) {
      /* private mode — fall through to a fresh number */
    }

    var mid = 300;
    var spread = 80;
    var u = (Math.random() + Math.random() + Math.random()) / 3;
    var count = Math.round(mid + (u * 2 - 1) * spread * 0.75);

    try {
      sessionStorage.setItem(SESSION_KEY, count);
    } catch (e) {
      /* ignore */
    }

    return count;
  }

  function init() {
    var badge = document.getElementById('mxpvBadge');
    var text = document.getElementById('mxpvText');
    if (!badge || !text) return;

    text.textContent = getCount() + ' people viewed this product in the last 24 hours';

    setTimeout(
      function () {
        badge.classList.add('mxpv-visible');
      },
      600 + Math.random() * 700,
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
